/**
 * Cupom de desconto e calculadora de frete (CEP) no carrinho.
 * Usa a Cart AJAX API nativa do Shopify:
 *  - POST /cart/update.js com { discount: "CODE" } aplica um codigo de desconto real ao carrinho
 *    (recurso disponivel desde maio/2025 na Cart AJAX API).
 *  - GET /cart/shipping_rates.json retorna as taxas de frete configuradas na loja para um CEP.
 */
(function () {
  function moneyBRL(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function sectionUrl(cartUrl, sectionId) {
    var url = cartUrl + '?section_id=' + sectionId;
    var previewParam = window.location.search.match(/(?:^|[?&])(preview_theme_id=[^&]+)/);
    if (previewParam) {
      url += '&' + previewParam[1];
    }
    return url;
  }

  function refreshCartDrawerTotals(sourceEl) {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    // Tanto o drawer quanto a pagina /cart completa podem ter uma copia deste
    // formulario no DOM ao mesmo tempo (o drawer e' renderizado globalmente,
    // so' fica escondido via CSS). Por isso decidimos o contexto a partir do
    // elemento que disparou a acao (sourceEl), nao de uma checagem global.
    var isDrawer = !!(sourceEl && sourceEl.closest && sourceEl.closest('#CartDrawer'));

    if (isDrawer) {
      return fetch(sectionUrl(cartUrl, 'cart-drawer'))
        .then(function (response) {
          return response.text();
        })
        .then(function (responseText) {
          var html = new DOMParser().parseFromString(responseText, 'text/html');
          ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
            var target = document.querySelector(selector);
            var source = html.querySelector(selector);
            if (target && source) {
              target.replaceWith(source);
            }
          });
        });
    }

    // Pagina /cart completa (fora do drawer): a Section Rendering API
    // (?section_id=...) nao respeita a pre-visualizacao de um tema nao
    // publicado -- ela sempre renderiza a partir do tema AO VIVO, mesmo com o
    // cookie de preview presente. Isso faz o fragmento voltar desatualizado
    // (ou de outro layout) enquanto estamos testando no tema de teste. Para
    // funcionar corretamente tanto em preview quanto depois de publicado,
    // buscamos a pagina /cart inteira (que respeita a pre-visualizacao) e
    // extraimos dela os mesmos elementos que substituiriamos via secao.
    var isFullCartPage = !!document.querySelector('#main-cart-items, #main-cart-footer');
    if (!isFullCartPage) return Promise.resolve();

    var fullPagePromise = fetch(cartUrl, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');

        var itemsTarget = document.querySelector('cart-items');
        var itemsSource = html.querySelector('cart-items');
        if (itemsTarget && itemsSource) {
          itemsTarget.replaceWith(itemsSource);
        }

        var footerTarget = document.querySelector('.cart-footer-totals-refresh');
        var footerSource = html.querySelector('.cart-footer-totals-refresh');
        if (footerTarget && footerSource) {
          footerTarget.replaceWith(footerSource);
        }
      });

    return fullPagePromise;
  }

  class CartDiscountForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.button = this.querySelector('button');
      this.messageEl = this.querySelector('.cart-discount-form__message');
      this.codesEl = this.querySelector('.cart-discount-form__codes');
      this.appliedCodes = [];

      this.button.addEventListener('click', this.onApply.bind(this));
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.onApply();
        }
      });
    }

    connectedCallback() {
      // Um cupom pode ja estar aplicado de uma visita anterior (sessao do carrinho).
      // Sincronizamos a lista local antes de aceitar novos cupons, para nao
      // substituir por engano um desconto que o cliente ja tinha aplicado.
      var cartJsonUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
      fetch(cartJsonUrl, { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => {
          this.appliedCodes = (cart.cart_level_discount_applications || [])
            .map((discount) => discount.title)
            .filter(Boolean);
          this.renderCodes();
        })
        .catch(() => {});
    }

    onApply() {
      var code = (this.input.value || '').trim();
      if (!code) return;

      if (this.appliedCodes.some((existing) => existing.toUpperCase() === code.toUpperCase())) {
        this.setMessage('Esse cupom ja esta aplicado.', 'error');
        return;
      }

      var cartUpdateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
      var cartJsonUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
      var normalizedCode = code.toUpperCase();
      // A Cart AJAX API aceita varios codigos numa unica chamada, separados por
      // virgula: "discount: 'CODE1,CODE2'". Reenviamos sempre a lista completa
      // (cupons ja confirmados + o novo), pois cada chamada substitui o conjunto
      // de descontos ativo no carrinho.
      var candidateList = this.appliedCodes.concat([code]);

      function hasCode(cart) {
        var atCartLevel = (cart.cart_level_discount_applications || []).some(
          (discount) => (discount.title || '').toUpperCase() === normalizedCode
        );
        var atLineLevel = (cart.items || []).some((item) =>
          (item.line_level_discount_allocations || []).some(
            (allocation) => (allocation.discount_application.title || '').toUpperCase() === normalizedCode
          )
        );
        return atCartLevel || atLineLevel;
      }

      this.setLoading(true);
      this.setMessage('');

      // O JSON bruto retornado por /cart/update.js nem sempre reflete o desconto
      // no mesmo instante da resposta. Por isso comparamos o total_discount do
      // carrinho antes e depois da chamada, em vez de confiar só no corpo do POST.
      fetch(cartJsonUrl, { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cartBefore) => {
          var baselineDiscount = cartBefore.total_discount || 0;

          return fetch(cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: candidateList.join(',') }),
          })
            .then(() => fetch(cartJsonUrl, { headers: { Accept: 'application/json' } }))
            .then((response) => response.json())
            .then((cartAfter) => {
              var applied = hasCode(cartAfter) || (cartAfter.total_discount || 0) > baselineDiscount;

              if (applied) {
                this.appliedCodes = candidateList;
                this.setMessage('Cupom "' + code + '" adicionado.', 'success');
                this.input.value = '';
              } else {
                this.setMessage(
                  'Cupom "' + code + '" invalido, expirado ou nao combinavel com os descontos ja aplicados.',
                  'error'
                );
              }

              this.renderCodes();
              return refreshCartDrawerTotals(this);
            });
        })
        .catch(() => {
          this.setMessage('Nao foi possivel aplicar o cupom agora. Tente novamente.', 'error');
        })
        .finally(() => this.setLoading(false));
    }

    removeCode(code) {
      var cartUpdateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
      var remaining = this.appliedCodes.filter((existing) => existing !== code);

      this.setLoading(true);
      this.setMessage('');

      fetch(cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: remaining.join(',') }),
      })
        .then(() => {
          this.appliedCodes = remaining;
          this.setMessage('Cupom "' + code + '" removido.', 'success');
          this.renderCodes();
          return refreshCartDrawerTotals(this);
        })
        .catch(() => {
          this.setMessage('Nao foi possivel remover o cupom agora. Tente novamente.', 'error');
        })
        .finally(() => this.setLoading(false));
    }

    renderCodes() {
      if (!this.codesEl) return;
      this.codesEl.innerHTML = '';

      if (!this.appliedCodes.length) {
        this.codesEl.hidden = true;
        return;
      }

      this.appliedCodes.forEach((code) => {
        var li = document.createElement('li');
        li.className = 'cart-discount-form__code';

        var label = document.createElement('span');
        label.textContent = code;
        li.appendChild(label);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'cart-discount-form__code-remove';
        removeBtn.setAttribute('aria-label', 'Remover cupom ' + code);
        removeBtn.textContent = String.fromCharCode(215);
        removeBtn.addEventListener('click', () => this.removeCode(code));
        li.appendChild(removeBtn);

        this.codesEl.appendChild(li);
      });

      this.codesEl.hidden = false;
    }

    setMessage(text, type) {
      this.messageEl.textContent = text;
      this.messageEl.classList.remove('cart-discount-form__message--success', 'cart-discount-form__message--error');
      if (type) this.messageEl.classList.add('cart-discount-form__message--' + type);
    }

    setLoading(isLoading) {
      this.button.disabled = isLoading;
      this.button.textContent = isLoading ? 'Aplicando...' : 'Aplicar';
    }
  }

  if (!customElements.get('cart-discount-form')) {
    customElements.define('cart-discount-form', CartDiscountForm);
  }

  class CartShippingEstimator extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.button = this.querySelector('button');
      this.messageEl = this.querySelector('.cart-shipping-estimator__message');
      this.resultsEl = this.querySelector('.cart-shipping-estimator__results');

      this.button.addEventListener('click', this.onCalculate.bind(this));
      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.onCalculate();
        }
      });
    }

    onInput() {
      var digits = this.input.value.replace(/\D/g, '').slice(0, 8);
      this.input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
    }

    onCalculate() {
      var cep = this.input.value.replace(/\D/g, '');

      this.resultsEl.hidden = true;
      this.resultsEl.innerHTML = '';
      this.setMessage('');

      if (cep.length !== 8) {
        this.setMessage('Digite um CEP valido (8 digitos).', 'error');
        return;
      }

      this.setLoading(true);

      // A Cart AJAX API do Shopify exige o estado (province) junto com o CEP para
      // calcular o frete no Brasil. Resolvemos o estado a partir do CEP via ViaCEP
      // (servico publico e gratuito) antes de consultar as taxas de frete.
      fetch('https://viacep.com.br/ws/' + cep + '/json/')
        .then((response) => {
          if (!response.ok) throw new Error('viacep_error');
          return response.json();
        })
        .then((address) => {
          if (address.erro) {
            this.setMessage('CEP nao encontrado.', 'error');
            this.setLoading(false);
            return null;
          }

          var params = new URLSearchParams({
            'shipping_address[zip]': cep,
            'shipping_address[country]': 'Brazil',
            'shipping_address[province]': address.uf,
          });

          return fetch('/cart/shipping_rates.json?' + params.toString(), { headers: { Accept: 'application/json' } });
        })
        .then((response) => {
          if (!response) return null;
          if (!response.ok) throw new Error('shipping_rates_error');
          return response.json();
        })
        .then((data) => {
          if (!data) return;
          var rates = data.shipping_rates || [];
          if (!rates.length) {
            this.setMessage('Nao encontramos opcoes de frete para este CEP.', 'error');
            return;
          }
          rates.forEach((rate) => {
            var li = document.createElement('li');
            li.className = 'cart-shipping-estimator__result';
            var priceCents = Math.round(parseFloat(rate.price) * 100);
            var nameEl = document.createElement('span');
            nameEl.textContent = rate.name;
            var priceEl = document.createElement('span');
            priceEl.textContent = priceCents === 0 ? 'Gratis' : moneyBRL(priceCents);
            li.appendChild(nameEl);
            li.appendChild(priceEl);
            this.resultsEl.appendChild(li);
          });
          this.resultsEl.hidden = false;
        })
        .catch(() => {
          this.setMessage('Nao foi possivel calcular o frete agora. Tente novamente.', 'error');
        })
        .finally(() => this.setLoading(false));
    }

    setMessage(text, type) {
      this.messageEl.textContent = text;
      this.messageEl.classList.remove('cart-shipping-estimator__message--error');
      if (type) this.messageEl.classList.add('cart-shipping-estimator__message--' + type);
    }

    setLoading(isLoading) {
      this.button.disabled = isLoading;
      this.button.textContent = isLoading ? 'Calculando...' : 'Calcular';
    }
  }

  if (!customElements.get('cart-shipping-estimator')) {
    customElements.define('cart-shipping-estimator', CartShippingEstimator);
  }
})();
